import useFormState from '../../../../hooks/useFormState';
import validationRules, {
  Model,
} from '../../report-outage/serviceLocation.rules';
import { OutageResultPanelData } from '../outage-map-panel/OutageResultsPanel';
import useUtils from '../utils';
import { useReportOutageApi } from '../outage-map-panel/useOutageReportApi';
import useWrapWithLoader from '../../../../hooks/useWrapWithLoading';

export const useAnonymousNotifSubmission = (data: OutageResultPanelData) => {
  const { getRequestSource, setErrorNotification } = useUtils();
  const { reportOutageForGuest } = useReportOutageApi();
  const { wrapWithLoader } = useWrapWithLoader();

  const defaultFormValues: Model = {
    receiveEmail: false,
    email: '',
    receiveText: false,
    textNumber: '',
    callbackPhoneNumber: '',
    receiveCallBack: false,
  };

  const form = useFormState(defaultFormValues, {
    validate: validationRules,
  });

  const setError = () => {
    window.scrollTo(0, 0);
    setErrorNotification(true);
  };

  let handleOnSubmitStatus: any;

  const encryptedServicePointList = data?.outageData?.encryptedServicePointIds
    ? data.outageData.encryptedServicePointIds
    : [String(data.outageData.encryptedServicePointId)];

  const handleOnSubmit = wrapWithLoader(
    async (accountNumber?: string | null, servicePointId?: string | null) => {
      try {
        handleOnSubmitStatus =
          form.values.callbackPhoneNumber.length >= 10 &&
          (data?.outageData?.encryptedAccountNumber || accountNumber) &&
          (encryptedServicePointList || servicePointId) &&
          (await reportOutageForGuest({
            encryptedAccountNumber: accountNumber
              ? accountNumber
              : data?.outageData?.encryptedAccountNumber
              ? data?.outageData?.encryptedAccountNumber
              : '',
            encryptedServicePointList: servicePointId
              ? [String(servicePointId)]
              : encryptedServicePointList,
            callbackPhone: form.values.callbackPhoneNumber,
            source: getRequestSource(),
          }));

        if (
          handleOnSubmitStatus?.reportOutageBySpListGuest?.success &&
          !Boolean(handleOnSubmitStatus?.reportOutageBySpListGuest?.success)
        ) {
          setError();
        }
        return Boolean(
          handleOnSubmitStatus?.reportOutageBySpListGuest?.success,
        );
      } catch {
        setError();
      }
    },
  );

  return {
    form,
    handleOnSubmit,
  };
};
export default useAnonymousNotifSubmission;
